import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, CircularProgress } from '@mui/material'; // Added CircularProgress
import UsuarioForm from '../components/UsuarioForm'; // New import
import { useAuth } from '../context/AuthContext'; // New import
import api from '../services/api'; // New import
import { useNavigate } from 'react-router-dom'; // New import

function ChangePasswordPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (user && user.id) {
      api.get(`/usuarios/${user.id}`)
        .then(response => {
          // The backend /usuarios/:id endpoint might return the full user object directly,
          // or a paginated response if it was modified. Let's assume direct for now.
          // If it returns { data: [...], totalCount: ... }, we'd need response.data.data[0]
          setUserData(response.data.data ? response.data.data[0] : response.data);
          setLoadingUser(false);
        })
        .catch(err => {
          console.error('Erro ao buscar dados do usuario:', err);
          setError('Nao foi possivel carregar os dados do usuario.');
          setLoadingUser(false);
        });
    } else {
      setLoadingUser(false);
      setError('Usuario nao logado.');
    }
  }, [user]);

  const handlePasswordChanged = () => {
    alert('Senha alterada com sucesso!');
    navigate('/'); // Redirect to home or dashboard after password change
  };

  const handleCancel = () => {
    navigate('/'); // Redirect to home or dashboard if cancelled
  };

  if (loadingUser) {
    return (
      <Container sx={{ mt: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container sx={{ mt: 4 }}>
        <Typography variant="h5" color="error">
          {error}
        </Typography>
      </Container>
    );
  }

  if (!userData) {
    return (
      <Container sx={{ mt: 4 }}>
        <Typography variant="h5" color="error">
          Dados do usuario nao encontrados.
        </Typography>
      </Container>
    );
  }

  return (
    <Container sx={{ mt: 4 }}>
      <Box>
        <Typography variant="h4" gutterBottom>
          Alterar Senha
        </Typography>
        <UsuarioForm
          onUsuarioAdded={handlePasswordChanged} // Renamed from onUsuarioAdded for clarity
          initialData={userData}
          onCancelEdit={handleCancel}
          isChangePasswordMode={true} // New prop to indicate mode
        />
      </Box>
    </Container>
  );
}

export default ChangePasswordPage;
